import Button from '@mui/material/Button';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { saveSupportReportDraft, supportReportPath } from '../../utils/supportReports';

const ReportIssueButton = ({ context = {}, size = 'small', variant = 'outlined', sx }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    const draftId = saveSupportReportDraft({
      category: 'bug',
      page: window.location.pathname,
      ...context,
    });

    navigate(supportReportPath(draftId));
  };

  return (
    <Button
      size={size}
      variant={variant}
      startIcon={<SupportAgentOutlinedIcon />}
      onClick={handleClick}
      sx={sx}
    >
      {t('support.reportIssue')}
    </Button>
  );
};

export default ReportIssueButton;
